<script setup>
import { useConfirm } from '~/composables/useConfirm'

const {
  close,
  message,
  visible,
  title,
  confirmLabel,
  cancelLabel,
  confirmColor,
  cancelColor,
  description,
  icon,
} = useConfirm()

const resolvedTitle = computed(() => title.value || 'Confirm Action')
const resolvedConfirmLabel = computed(() => confirmLabel.value || 'Confirm')
const resolvedCancelLabel = computed(() => cancelLabel.value || 'Cancel')
const resolvedConfirmColor = computed(() => confirmColor.value || 'primary')
const resolvedCancelColor = computed(() => cancelColor.value || 'neutral')
</script>

<template>
  <UModal v-model:open="visible" :ui="{ container: 'items-start', width: 'sm:max-w-md' }">
      <template #header>
        <div class="flex items-start gap-3">
          <UIcon v-if="icon" :name="icon" class="mt-0.5 h-5 w-5 text-warning-500" />
          <div>
            <h3 class="text-base font-semibold leading-6">{{ resolvedTitle }}</h3>
          </div>
        </div>
      </template>

      <template #body>
        <div class="space-y-2">
          <p class="text-sm text-neutral-600 dark:text-neutral-300">{{ message }}</p>
          <p v-if="description" class="text-sm text-neutral-500 dark:text-neutral-400">{{ description }}</p>
        </div>
      </template>

      <template #footer>
        <div class="flex justify-end gap-2">
          <UButton :color="resolvedCancelColor" variant="ghost" class="cursor-pointer" @click="close(false)">{{ resolvedCancelLabel }}</UButton>
          <UButton :color="resolvedConfirmColor" class="cursor-pointer" @click="close(true)">{{ resolvedConfirmLabel }}</UButton>
        </div>
      </template>
  </UModal>
</template>
